"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createCompanyReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _ReferenceObjectTypes = _interopRequireDefault(require("reference-resolvers/constants/ReferenceObjectTypes"));

var _ContactSearchAPI = require("reference-resolvers/api/ContactSearchAPI");

var createCompanyReferenceResolver = function createCompanyReferenceResolver(options) {
  return (0, _createBatchedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.COMPANIES,
    createFetchByIds: function createFetchByIds(opts) {
      return (0, _ContactSearchAPI.createGetObjectsByIds)(opts)(_ReferenceObjectTypes.default.COMPANY);
    },
    createFetchSearchPage: function createFetchSearchPage(opts) {
      return (0, _ContactSearchAPI.createSearchObjects)(opts)(_ReferenceObjectTypes.default.COMPANY);
    },
    fetchByIds: (0, _ContactSearchAPI.getObjectsByIds)(_ReferenceObjectTypes.default.COMPANY),
    fetchSearchPage: (0, _ContactSearchAPI.searchObjects)(_ReferenceObjectTypes.default.COMPANY)
  }, options));
};

exports.createCompanyReferenceResolver = createCompanyReferenceResolver;

var _default = createCompanyReferenceResolver();

exports.default = _default;